import React, { useEffect, useContext } from "react";
import { AppContext, DispatchContext } from "../AppContext";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import * as actions from '../actions/actions';
import Button from '@material-ui/core/Button';
import { makeStyles } from "@material-ui/styles";
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Checkbox from '@material-ui/core/Checkbox';
import Divider from '@material-ui/core/Divider';

const useStyles = makeStyles((theme) => ({
    root: {
        margin: 'auto',
    },
    cardHeader: {
        padding: theme.spacing(1, 2),
    },
    list: {
        width: 400,
        height: 330,
        backgroundColor: theme.palette.background.paper,
        overflow: 'auto',
    },
    button: {
        margin: theme.spacing(0.5, 0),
    },
    dialogContent: {
        background: "#F5F5F5",
        padding: "0 10px 5px 6px"
    },
    dialogPaper: {
        minHeight: 550,
    },
    dialogTitle: {
        padding: "10px 17px"
    }
}));

const not = (a, b) => {
    return a.filter((value) => b.indexOf(value) === -1);
}

const intersection = (a, b) => {
    return a.filter((value) => b.indexOf(value) !== -1);
}

const union = (a, b) => {
    return [...a, ...not(b, a)];
}

export default function ProjectsDialog(props) {
    const { openDialog, closeDialog, handlesourceCheckbox } = props;
    const state = useContext(AppContext);
    const s = state.strings;
    const dispatch = useContext(DispatchContext);

    const classes = useStyles();
    const [checked, setChecked] = React.useState([]);
    const [left, setLeft] = React.useState([]);
    const [right, setRight] = React.useState(state.newCheckSettings.searchInLibraryProjects || []);
    const leftChecked = intersection(checked, left);
    const rightChecked = intersection(checked, right);

    useEffect(() => {

        // Dialog was opened with search in lib checked, but no projects selected => set all projects right (included)
        if (state.newCheckSettings.searchLib && state.newCheckSettings.searchInLibraryProjects.length == 0) {
            setRight([{ Id: 0, Name: '[Unassigned library texts]' }, ...state.projects]);
            return;
        }

        const leftData = [{ Id: 0, Name: '[Unassigned library texts]' }, ...state.projects].filter(project => !state.newCheckSettings.searchInLibraryProjects.some(selectedProject => project.Id === selectedProject.Id));
        setLeft([...left, ...leftData]);
    }, []);

    const handleToggle = (value) => () => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setChecked(newChecked);
    };

    const numberOfChecked = (items) => intersection(checked, items).length;

    const handleToggleAll = (items) => () => {
        if (numberOfChecked(items) === items.length) {
            setChecked(not(checked, items));
        } else {
            setChecked(union(checked, items));
        }
    };

    const handleCheckedRight = () => {
        setRight(right.concat(leftChecked));
        setLeft(not(left, leftChecked));
        setChecked(not(checked, leftChecked));
    };

    const handleCheckedLeft = () => {
        setLeft(left.concat(rightChecked));
        setRight(not(right, rightChecked));
        setChecked(not(checked, rightChecked));
    };

    const handleChosenProjects = () => {
        dispatch(actions.setNewCheckSettings({ searchInLibraryProjects: right || [], searchLib: right.length > 0 }));
        closeDialog();
    }

    const handleCloseDialog = () => {
        closeDialog();
    }

    const customList = (title, items, s) => (
        <Card>
            <CardHeader
                className={classes.cardHeader}
                avatar={
                    <Checkbox
                        onClick={handleToggleAll(items)}
                        checked={numberOfChecked(items) === items.length && items.length !== 0}
                        indeterminate={numberOfChecked(items) !== items.length && numberOfChecked(items) !== 0}
                        disabled={items.length === 0}
                        inputProps={{ 'aria-label': 'all items selected' }}
                    />
                }
                title={title}
                titleTypographyProps={{variant:"h6", color:"primary"}}
                subheader={s.selectLibraryProjects.selectedCount.format(items.length)}
                subheaderTypographyProps={{variant:"body2", color:"secondary"}}
            />
            <Divider />
            <List className={classes.list} dense component="div" role="list">
                {items.map((data) => {
                    const { Name, Id } = data || {};
                    const labelId = `transfer-list-all-item-${Id}-label`;

                    return (
                        <ListItem style={{ height: 40 }} key={Id} role="listitem" button onClick={handleToggle(data)}>
                            <ListItemIcon>
                                <Checkbox
                                    checked={checked.indexOf(data) !== -1}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{ 'aria-labelledby': labelId }}
                                />
                            </ListItemIcon>
                            <ListItemText id={labelId} primary={Name} />
                        </ListItem>
                    );
                })}
                <ListItem />
            </List>
        </Card>
    );

    return (
        <div>
            <Dialog className={classes.dialogPaper} maxWidth='md' disableBackdropClick={true} aria-labelledby="customized-dialog-title" open={openDialog}>
                <DialogTitle className={classes.dialogTitle}>
                    {s.selectLibraryProjects.selectProjects}
                </DialogTitle>

                <DialogContent dividers>
                    <div className={classes.dialogContent}>
                        <Grid container spacing={2} justify="center" alignItems="center" className={classes.root}>
                            <Grid item>{customList(s.selectLibraryProjects.choices, left, s)}</Grid>
                            <Grid item>
                                <Grid container direction="column" alignItems="center">
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        className={classes.button}
                                        onClick={handleCheckedRight}
                                        disabled={leftChecked.length === 0}
                                        aria-label="move selected right"
                                    >
                                        &gt;
          </Button>
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        className={classes.button}
                                        onClick={handleCheckedLeft}
                                        disabled={rightChecked.length === 0}
                                        aria-label="move selected left"
                                    >
                                        &lt;
          </Button>
                                </Grid>
                            </Grid>
                            <Grid item>{customList(s.selectLibraryProjects.chosen, right, s)}</Grid>
                        </Grid>
                    </div>
                </DialogContent>
                <DialogActions >
                    <Button variant="contained" color="primary" onClick={handleChosenProjects}>
                        <span>Ok</span>
                    </Button>
                    <Button variant="contained" color="primary" onClick={handleCloseDialog}>
                        <span> Cancel </span>
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}